/** FollowRequestCard.js:
 *  Represents a single join request notification, showing the sender's avatar and name,
 *  with Approve/Reject buttons and an optional profile popup on avatar click.
 */

// ===============================
// Imports
// ===============================
import React from 'react';
import { Typography, Box, Avatar, Dialog } from '@mui/material';
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

import './FollowRequestCard.css'; // Styling specific to this component
import ProfileDialog from './ProfileDialog';

// ===============================
// Component: FollowRequestCard
// ===============================
const NotificationCard = ({
    profile,
    onApprove,
    onDeny,
    onCardClick,
    onDelete,
    isUnread = false,
    message,
    type,
}) => {
    const [isUserOpen, setIsUserOpen] = React.useState(false); // Controls profile dialog
    const isActionable = type !== "join_rejected_full_single";

    // === Open the user's profile when avatar is clicked ===
    const handleAvatarClick = (e) => {
        e.stopPropagation(); // Prevent card click (navigation)
        setIsUserOpen(true);
    };

    return (
        <>
            {/* === Notification Card Container === */}
            <Box
                onClick={onCardClick}
                className={`notification-item ${isUnread ? "unread" : ""}`}
                style={{ cursor: onCardClick ? "pointer" : "default" }}
            >
                {/* === Avatar and Text === */}
                <Box className="notification-content">
                    <Avatar
                        src={profile.image || "/default-avatar.png"}
                        alt={profile.title}
                        className="notification-avatar"
                        onClick={handleAvatarClick}
                    />
                    <Typography className="notification-text">
                        {message || (
                            <>
                                <strong>{profile.title}</strong> רוצה להצטרף אלייך לטיול
                            </>
                        )}
                    </Typography>
                </Box>

                {/* === Approve/Reject Buttons === */}
                <Box className="notification-actions">
                    {onApprove && onDeny && isActionable ? (
                        <>
                            <button type="button"
                                className="notification-approve"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    onApprove?.(e);
                                }}
                            >
                                אשר
                            </button>
                            <button type="button"
                                className="notification-reject"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    onDeny?.(e);
                                }}
                            >
                                דחה
                            </button>
                        </>
                    ) : null}
                    {/* Always show X button to allow closing any notification */}
                    {onDelete && (
                        <IconButton
                            size="small"
                            aria-label="close"
                            color="inherit"
                            onClick={(e) => {
                                e.stopPropagation();
                                onDelete?.(e);
                            }}
                        >
                            <CloseIcon fontSize="small" />
                        </IconButton>
                    )}
                </Box>
            </Box>

            {/* === Profile Dialog Popup === */}
            <Dialog
                sx={{ zIndex: "9999" }}
                maxWidth="lg"
                open={isUserOpen}
                onClose={() => setIsUserOpen(false)}
            >
                <ProfileDialog open={isUserOpen} profileId={profile.id} onClose={() => setIsUserOpen(false)} />
            </Dialog>
        </>
    );
};

export default NotificationCard;
